<template>
    <div class="activity__block">
        <!-- Favorite button - added directly to ListItem -->
        <div class="favorite-container" v-if="showFavoriteButton">
            <favorite-button 
                :player-id="getSafeActivityId()"
                :add-to-favorites-text="addToFavoritesText"
                :remove-from-favorites-text="removeFromFavoritesText"
                :initial-is-favorite="initialIsFavorite"
                :item-type="'activity'"
                @before-remove="$emit('before-remove', activityItem)"
            />
        </div>

        <figure v-html='activityItem.featured_media'></figure>

        <!-- <div class="activity__block__content"> -->

        <div  class="activity__type__holder" >
            <div class="activity__type generic-medium" v-for="type in this.activityItem.type">
                {{ type.name }}
                <span></span>
            </div>

        </div>

        <h4>
            {{ activityItem.post_title }}
        </h4>

        <div v-if="activityItem.acf.description" v-html="activityItem.acf.description" class="content">
        </div>

        <ul class="activity__block__details">
            <li>
                <div v-html="ico_pin"></div>
                <span class="generic-medium"> {{ activityItem.acf.location }}</span>
            </li>
            <li>
                <div v-html="ico_calendar"></div>
                <span class="generic-medium">{{ formatDate }}</span>
            </li>
            <li>
                <div v-html="ico_clock"></div>
                <span class="generic-medium">{{time}}</span>
            </li>
        </ul>
        <!-- </div> -->

    </div>

</template>

<script>
import FavoriteButton from '../players/FavoriteButton.vue';

export default {
    props: {
        activityItem: Object,
        // Favorite button props
        showFavoriteButton: {
            type: Boolean,
            default: false
        },
        favoritesId: {
            type: [String, Number],
            default: function() {
                return this.activityItem && this.activityItem.id ? this.activityItem.id : null;
            }
        },
        addToFavoritesText: {
            type: String,
            default: 'Add to favorites'
        },
        removeFromFavoritesText: {
            type: String,
            default: 'Remove from favorites'
        },
        initialIsFavorite: {
            type: Boolean,
            default: false
        }
    },
    components: {
        FavoriteButton
    },
    data() {
        return {
            ico_pin: window.ico_pin || this.$parent.ico_pin,
            ico_calendar: window.ico_calendar || this.$parent.ico_calendar,
            ico_clock: window.ico_clock || this.$parent.ico_clock,
        }
    },
    created() {
        // console.log('=== ACTIVITY LIST ITEM DEBUG ===');
        // console.log('Activity item:', this.activityItem);
        // console.log('Activity ID used for favorites:', String(this.activityItem.post_id || this.activityItem.id || this.favoritesId));
        // console.log('Show favorite button:', this.showFavoriteButton);
    },
    mounted() {
        // Log whether FavoriteButton component is registered
        // console.log('FavoriteButton component registered:', !!this.$options.components.FavoriteButton);
    },
    computed:{
        time() {
            if(!this.activityItem.acf.start_time){
                return '';
            }

            if ( ! this.activityItem.acf.end_time || this.activityItem.acf.start_time == this.activityItem.acf.end_time ) {
                return this.activityItem.acf.start_time;
            }

            return (this.activityItem.acf.start_time + " - " + this.activityItem.acf.end_time );
        },
        types() {
            if(this.activityItem.type.length > 0){
                let typesArray = []
                for(let i=0; i < this.activityItem.type.length; i++) {
                    typesArray[i]=this.activityItem.type[i].name;
                }

                return typesArray.toString();
            }else{
                return ''
            }
        },
        formatDate() {
            if (!this.activityItem.acf.date) {
                return '';
            }

            const dateParts = this.activityItem.acf.date.split('/');
            if (dateParts.length !== 3) {
                return this.activityItem.acf.date;
            }

            const month = parseInt(dateParts[0], 10);
            const day = parseInt(dateParts[1], 10);
            const year = parseInt(dateParts[2], 10);

            const date = new Date(year, month - 1, day);
            const options = { weekday: 'long', month: 'short', day: 'numeric' };
            const formattedDate = date.toLocaleDateString('en-US', options);

            return formattedDate;
        }
    },
    methods: {
        getSafeActivityId() {
            // console.log('Getting safe activity ID from:', {
            //     post_id: this.activityItem.post_id,
            //     ID: this.activityItem.ID, // WordPress often uses uppercase ID
            //     id: this.activityItem.id,
            //     favoritesId: this.favoritesId
            // });
            
            // Check for ID in various formats - WordPress often uses uppercase ID
            
            // 1. First check for regular ID (uppercase) as it's the primary WordPress ID
            if (this.activityItem.ID && !isNaN(parseInt(this.activityItem.ID, 10))) {
                const id = parseInt(this.activityItem.ID, 10);
                // console.log('Using uppercase ID:', id);
                return String(id);
            }
            
            // 2. Next check for post_id
            if (this.activityItem.post_id && !isNaN(parseInt(this.activityItem.post_id, 10))) {
                const id = parseInt(this.activityItem.post_id, 10);
                // console.log('Using post_id:', id);
                return String(id);
            }
            
            // 3. Next try regular id property (lowercase)
            if (this.activityItem.id && !isNaN(parseInt(this.activityItem.id, 10))) {
                const id = parseInt(this.activityItem.id, 10);
                // console.log('Using lowercase id:', id);
                return String(id);
            }
            
            // 4. Try favoritesId prop
            if (this.favoritesId && !isNaN(parseInt(this.favoritesId, 10))) {
                const id = parseInt(this.favoritesId, 10);
                // console.log('Using favoritesId:', id);
                return String(id);
            }
            
            // If we get here, we couldn't find a numeric ID
            // Use post name or title with activity- prefix for consistent string IDs
            if (this.activityItem.post_name) {
                const stringId = `activity-${this.activityItem.post_name.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`;
                // console.log('Using post_name for string ID:', stringId);
                return stringId;
            }
            
            if (this.activityItem.post_title) {
                const stringId = `activity-${this.activityItem.post_title.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`;
                // console.log('Using post_title for string ID:', stringId);
                return stringId;
            }
            
            // Last resort fallback
            const fallbackId = `activity-${Date.now()}`;
            // console.log('Using fallback ID:', fallbackId);
            return fallbackId;
        }
    }
}


</script>

<style scoped>
.favorite-container {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 10;
}
</style>
